module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "aria-label": "35",
      "epub:type": "pagebreak",
      "id": "page35",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "part-number-with-part-title",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part Two:")])]), _vm._v(" "), _c('p', {
    staticClass: "part-title-with-part-number"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RUBY TUESDAY")])]), _vm._v(" "), _c('p', {
    staticClass: "part-ornament"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pacific Ocean")])]), _vm._v(" "), _c('p', {
    staticClass: "part-ornament"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("200 Nautical Miles ENE of the Hawaiian Islands")])]), _vm._v(" "), _c('p', {
    staticClass: "part-ornament"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Present Day")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d62fae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504096065-4.vue
// module id = 84
// module chunks = 0